export default __webpack_public_path__ + "static/IN-9408WQHD-vs-IN-9008FHD_day2_thumb-f7e020efbcf754c278cf0685cb60731c.webp";